import ReminderSlice from './reminderSlice';
// REMOVED: All Redux config selectors have been migrated to React Query
import geoLocationSlice from './geoLocationSlice';
import headerSlice from './headerSlice';
import liveTvSlice from './liveTvSlice';
import miniEpgSlice from './miniEpgSlice';
import playerSlice from './playerSlice';
import screenHistorySlice from './screenHistorySlice';
// import subscriptionTireSlice from './subscriptionTireSlice';
import userSlice from './userSlice';
import overlayScreenSlice from './overlayScreenSlice';
import profileSlice from './profileSlice';
import userRevisionSlice from './userRevisionSlice';
import generalConfigurationSlice from './generalConfigurationSlice';
import moodsRecommendationSlice from './moodsRecommendationSlice';
import movieOverlayScreenSlice from './movieOverlayScreenSlice';
import castCrewModalSlice from './castCrewModalSlice';

const rootReducer = {
    reminder: ReminderSlice,
    // REMOVED: config reducer - React Query is now the single source of truth
    location: geoLocationSlice,
    header: headerSlice,
    liveTv: liveTvSlice,
    miniEpg: miniEpgSlice,
    player: playerSlice,
    screenHistory: screenHistorySlice,
    user: userSlice,
    overlay: overlayScreenSlice,
    profile: profileSlice,
    revision: userRevisionSlice,
    generalConfiguration: generalConfigurationSlice,
    moodsRecommendation: moodsRecommendationSlice,
    movieOverlay: movieOverlayScreenSlice,
    castCrewModal: castCrewModalSlice,
};

export default rootReducer;
